import { Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { DateTime } from "luxon";
import { RenewalEmail } from "../../../../types/Order/RenewalEmail";

interface RenewalEmailTableProps {
  emails: RenewalEmail[];
}

const formatEmailType = (emailType: string): string =>
  emailType.replace(/([A-Z])/g, " $1").trim();

const RenewalEmailTable = ({ emails }: RenewalEmailTableProps) => {
  if (emails.length === 0) {
    return <p className="text-muted">No renewal emails found.</p>;
  }

  return (
    <Table striped bordered hover size="sm" className="mt-3 text-center">
      <thead>
        <tr>
          <th>Type</th>
          <th>Time</th>
          <th>Delivered</th>
          <th>Link Clicked</th>
        </tr>
      </thead>
      <tbody>
        {emails.map((email) => (
          <tr key={email.id}>
            <td>{formatEmailType(email.emailType)}</td>
            <td>{DateTime.fromISO(email.sent).toFormat("dd/MM/yyyy HH:mm")}</td>
            <td className="text-center">
              <FontAwesomeIcon
                icon={email.deliverySuccess ? faCheck : faTimes}
                style={{ color: email.deliverySuccess ? "green" : "red" }}
              />
            </td>
            <td className="text-center">
              <span
                title={
                  email.linkClickedTime ?
                    DateTime.fromISO(email.linkClickedTime).toFormat(
                      "dd/MM/yyyy HH:mm",
                    )
                  : undefined
                }
              >
                <FontAwesomeIcon
                  icon={email.linkClickedTime ? faCheck : faTimes}
                  style={{ color: email.linkClickedTime ? "green" : "red" }}
                />
              </span>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default RenewalEmailTable;
